/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method,payload) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`,payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export async function loadOgTeamDetailsApi(searchFilter) {
  // let payload = { isMode:2 }

  if (searchFilter) {
    return await api
      .post(`/get-productivity-Quantity-report`, searchFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get-productivity-Quantity-report`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

export async function loadStatusApi(statusDetails) {
  // let payload = { isMode:2 }

  if (statusDetails) {
    return await api
      .post(`/get_Production_Deliverable_processStatus`, statusDetails)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_Production_Deliverable_processStatus`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

const remotes = {
  loadOgTeamDetailsApi,
  loadRecordsMetaData,
  loadStatusApi
}

export default remotes
